export enum SvcDelimiterType {
  DOT = 0,
  COMMA = 1,
}

export const DEFAULT_DELIMITER_TYPE = SvcDelimiterType.COMMA;
